import { defineStore } from 'pinia';
import api from '@/Services/api';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        profile: null,
        token: localStorage.getItem('token') || null,
        isAuthenticated: !!localStorage.getItem('token'),
        loading: false,
        error: null
    }),

    actions: {
        async login(credentials) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/users/login', {
                    email: credentials.email,
                    password: credentials.password
                });
                this.token = response.data.access_token;

                // Fetch user data
                const userResponse = await api.get('/users/me', {
                    headers: { Authorization: `Bearer ${this.token}` }
                });
                this.user = userResponse.data;

                this.isAuthenticated = true;
                localStorage.setItem('token', this.token);
                if (this.user && this.user.userId) {
                    localStorage.setItem('userId', this.user.userId);
                }
                return true;
            } catch (err) {
                this.error = err.response?.data?.detail || 'Login failed';
                return false;
            } finally {
                this.loading = false;
            }
        },
        async initializeAuth() {
            if (this.token && !this.user) {
                try {
                    const userResponse = await api.get('/users/me', {
                        headers: { Authorization: `Bearer ${this.token}` }
                    });
                    console.log('users/me response:', userResponse.data); // to be commented out 
                    this.user = userResponse.data;
                    this.isAuthenticated = true;
                    if (this.user && this.user.userId) {
                        localStorage.setItem('userId', this.user.userId);
                    }
                    // Fetch profile info as well
                    await this.fetchMyProfile();
                } catch (err) {
                    // Token invalid, clear it
                    this.logout();
                }
            }
        },
        async signup(userData) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/users/', {
                    username: userData.username,
                    email: userData.email,
                    password: userData.password
                });

                this.token = response.data.access_token;
                this.user = response.data.user;
                this.isAuthenticated = true;

                localStorage.setItem('token', this.token);
                if (this.user && this.user.userId) {
                    localStorage.setItem('userId', this.user.userId);
                }

                return true;
            } catch (err) {
                this.error = err.response?.data?.detail || 'Registration failed';
                console.error(this.error);
                return false;
            } finally {
                this.loading = false;
            }
        },

        async completeProfile(profileData) {
            this.loading = true;
            this.error = null;
            try {
                const formData = new FormData();
                Object.keys(profileData).forEach(key => {
                    if (profileData[key] !== null && profileData[key] !== undefined) {
                        formData.append(key, profileData[key]);
                    }
                });

                const response = await api.post('/UserProfile/create', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                
                // Update user state if response contains updated user
                if (response.data && response.data.user) {
                    this.user = response.data.user;
                }
                
                return true;
            } catch (err) {
                this.error = err.response?.data?.detail || err.response?.data?.message || 'Profile completion failed';
                console.error('Profile submission error:', err);
                return false;
            } finally {
                this.loading = false;
            }
        },
//  get user profile
        async fetchProfile(userId) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get(`/UserProfile/${userId}`);
                return response.data;
            } catch (err) {
                this.error = err.response?.data?.detail || err.response?.data?.message || 'Failed to load profile';
                console.error('Fetch profile error:', err);
                return null;
            } finally {
                this.loading = false;
            }
        },

        async fetchMyProfile() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get('/UserProfile/me');
                this.profile = response.data;
                return response.data;
            } catch (err) {
                this.error = err.response?.data?.detail || err.response?.data?.message || 'Failed to load your profile';
                console.error('Fetch my profile error:', err);
                return null;
            } finally {
                this.loading = false;
            }
        },

        async fetchAllUsers() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get('/UserProfile/UserProfiles');
                return response.data;
            } catch (err) {
                this.error = err.response?.data?.detail || err.response?.data?.message || 'Failed to load users';
                console.error('Fetch users error:', err);
                return [];
            } finally {
                this.loading = false;
            }
        },

        logout() {
            this.user = null;
            this.token = null;
            this.isAuthenticated = false;
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
        },

        clearError() {
            this.error = null;
        }
    }
});
